import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { TwoFAService } from '../two-fa.service';
import { MatDialog } from '@angular/material/dialog';
import { TwoFAComponent } from '../two-fa.component';

@Component({
  selector: 'tech-two-faok',
  templateUrl: './two-faok.component.html',
  styleUrls: ['./two-faok.component.scss']
})
export class TwoFAokComponent implements OnInit {
  public faCheck = faCheck;

  constructor(
    private router: Router,
    private twoFAService: TwoFAService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.twoFAService.showBtoCloseModalSource.next(false);
  }

  public goNextOK(event){
    this.router.navigate(['/portfolios']);
  }
}
